export default __webpack_public_path__ + "static/media/fotochallenge.6e11abca.jpg";